import { Mic, Square } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface RecordButtonProps {
  isRecording: boolean;
  onClick: () => void;
  disabled?: boolean;
}

const RecordButton = ({ isRecording, onClick, disabled = false }: RecordButtonProps) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <Button
        onClick={onClick}
        size="lg"
        disabled={disabled}
        className={cn(
          "h-16 w-16 rounded-full transition-all",
          isRecording 
            ? "bg-red-500 hover:bg-red-600 animate-pulse" 
            : "bg-indigo-600 hover:bg-indigo-700",
          disabled && "opacity-50 cursor-not-allowed"
        )}
      >
        {isRecording ? (
          <Square className="h-6 w-6" />
        ) : (
          <Mic className="h-6 w-6" />
        )}
      </Button>
      <p className="text-sm">
        {isRecording ? "Stop Recording" : "Start Recording"}
      </p>
    </div>
  );
};

export default RecordButton;
